module.exports = __webpack_public_path__ + "media/images/emblems/Wappen_Hemishofen-4c4e3775d25bd47bbc360a44666a38b4.png";